// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "../header/HeaderComponent";
import Footer from "../footer/FooterComponent";
import Seo from "../Seo/SeoComponent";
import styles from "./aboutPage.module.scss";
import { useLocalizedPath } from "../../i18n/localizedPath";
import PageLanguageLink from "../PageLanguageLink/PageLanguageLink";

function AboutPage() {
    const lp = useLocalizedPath();
    const { t, i18n } = useTranslation("aboutPage");
    const isPt = i18n.language === "pt";
    const switchPath = isPt ? "/about" : "/pt/about";
    const currentPath = isPt ? "/pt/about" : "/about";
    const features: string[] = t("features.list", { returnObjects: true });

    return (
        <div className={styles.page}>
            <Seo
                title={t("seoTitle")}
                description={t("seoDescription")}
                path={currentPath}
                lang={isPt ? "pt-PT" : undefined}
            />
            <Header />

            <main className={styles.main}>
                <section className={styles.container}>
                    <h1 className={styles.title}>{t("title")}</h1>
                    <p className={styles.description}>{t("description")}</p>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>{t("mission.heading")}</h2>
                        <p className={styles.cardText}>{t("mission.text")}</p>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>{t("features.heading")}</h2>
                        <p className={styles.featureDate}>{t("features.asOf")}</p>
                        <ul className={styles.featureList}>
                            {features.map((feature) => (
                                <li key={feature}>{feature}</li>
                            ))}
                        </ul>
                        <p className={styles.releaseLinkText}>
                            {t("features.releaseLinkPrefix")}{" "}
                            <Link to={lp("/releases")} className={styles.releaseLink}>{t("features.releaseLinkText")}</Link>{" "}
                            {t("features.releaseLinkSuffix")}
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>{t("credits.heading")}</h2>
                        <p className={styles.cardText}>{t("credits.text")}</p>
                    </div>

                    <PageLanguageLink to={switchPath} />
                </section>
            </main>

            <Footer />
        </div>
    );
}

export default AboutPage;
